import {TAB_ENABLE, TAB_DISABLE, TAB_SHOW} from '../../../../common/tabs/tabs.constants';
import { GRID_RELOAD } from '../../../../common/grid/grid.constants';
import { TYPES } from '../settings-action-type.constants';
import { TYPES as ACC_TYPES } from '../../accreditation-action-type.constants';
import { IDS } from '../settings-action-id.constants';
import * as AccreditationActions from '../../accreditation.actions'
import * as SettingsActions from '../settings.actions'
import * as Actions from './requirements.actions';

class RequirementsController {
    constructor($ngRedux, $state, $filter, $scope, $uiRouterGlobals, NavigationService, DocumentManager) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$filter = $filter;
        this.$scope = $scope;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.NavigationService = NavigationService;
        this.DocumentManager = DocumentManager;
    }

    $onInit() {
        this.unsubscribe = this.$ngRedux.connect( state => {
            const frameworkDetails = state.accreditation.accSettings.frameworkDetails
            const requirementDetails = state.accreditation.accSettings.requirementDetails
            return {
                frameworkDetails,
                treeData:               state.accreditation.simpleSectionsTree,
                showNodeDetails:        requirementDetails?.id || requirementDetails?.number,
                digits: {
                    level1_num_format:  frameworkDetails.level1_num_format,
                    level2_num_format:  frameworkDetails.level2_num_format,
                    level3_num_format:  frameworkDetails.level3_num_format,
                }
            };
        }, {...AccreditationActions, ...SettingsActions, ...Actions})(this);
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.iconSvg;

        this.treeViewOptions = {
            showIcon: true,
            expandOnClick: false
        };
        this.$scope.$on('selection-changed', this.onTreeSelectionChange.bind(this));
        this.$ngRedux.dispatch({
            type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
        });
        this.schemeCode = this.$uiRouterGlobals.params.itemCode;
        this.getRegulatoryFrameworkDetails(this.schemeCode);
        this.fetchFrameworkRequirementsTree(this.schemeCode);
    }

    onTreeSelectionChange(event, node) {
        node.schemeCode = this.schemeCode;
        this.getFrameworkRequirementDetails(node).then(() => {

            if(node.level === 3) { // is activity
                this.$ngRedux.dispatch({
                    type: GRID_RELOAD,
                    id:   IDS.accSettings,
                    path: IDS.assessmentGrid,
                })
            }
        });
    };

    onBtnAddCategory() {
        this.detailsTitle = this.$filter('translate')('ACCREDITATION.SETTINGS.REQUIREMENTS.ADD_MAIN_SECTION');
        this.$ngRedux.dispatch({
            type: ACC_TYPES.SIMPLE_STD_TREE_UNSELECT_ALL,
        });
        const siblings = this.treeData.map(item => String(item.numberRaw));
        const numberInputSelect = [];
        for(let i = 1; i < 100; i     ++) {
            if(siblings.includes(String(i)) === false) {
                numberInputSelect.push({
                    label: String(i),
                    value: i,
                });
            }
        }
        const formattedNumberInputSelect = numberInputSelect.map(item => {
            const sectionsArr = item.label.split('.')
            const digitsArr = Object.values(this.digits)
            const formattedNumber = sectionsArr.map((number, index) => {
                return number.padStart(digitsArr[index], '0')
            })
            return {
                value: item.value,
                label: formattedNumber.join('.')
            }
        })
        this.$ngRedux.dispatch({
            type:   TYPES.REQUIREMENT_DETAILS_REFRESH,
            id:     IDS.accreditationSettingsRequirementDetails,
            data:   {
                number: numberInputSelect[0].value,
                numberInputSelect: formattedNumberInputSelect,
                modulePrefixInputSelect: JSON.parse(this.frameworkDetails.module_prefixes || '[]').map(item => ({label: item, value: item})),
                siblings
            },
        });
    }

    onBtnExport() {
        this.exportRequirementsFile(this.schemeCode, this.DocumentManager.downloadFile);
    }

    onBtnImport() {
        this.$ngRedux.dispatch({
            type: TAB_SHOW,
            id: IDS.app_accreditation_scheme_settings_requirements,
            state: [IDS.app_accreditation_scheme_settings_requirements_imports]
        })
    }

    $onDestroy() {
        this.unsubscribe();
    }
}

RequirementsController.$inject = ['$ngRedux', '$state', '$filter', '$scope', '$uiRouterGlobals', 'NavigationService','DocumentManager'];

export const requirements = {
    controller: RequirementsController,
    template: `
        <tabs-header title="{{$ctrl.frameworkDetails.title}}"></tabs-header>
        <div layout-gt-xs="row">
            <div layout="column" flex="40">
                <tree nodes='$ctrl.treeData' options='$ctrl.treeViewOptions' flex></tree>
                <div layout-align="start center">
                    <md-button class="btnDefault" ng-click="$ctrl.onBtnAddCategory()">
                        {{'ACCREDITATION.SETTINGS.REQUIREMENTS.BTN_CREATE_CATEGORY' | translate}}
                    </md-button>
                    <md-button class="btnDefault" ng-click="$ctrl.onBtnExport()">
                        {{'ACCREDITATION.SETTINGS.REQUIREMENTS.BTN_EXPORT_REQUIREMENTS' | translate}}
                    </md-button>
                    <md-button class="btnDefault" ng-click="$ctrl.onBtnImport()">
                        {{'ACCREDITATION.SETTINGS.REQUIREMENTS.BTN_IMPORT_REQUIREMENTS' | translate}}
                    </md-button>
                </div>
            </div>
            <requirement-details flex
                    ng-show="$ctrl.showNodeDetails"
                    title="$ctrl.detailsTitle">
            </requirement-details>
            <disabled-locations
        </div>`
}
